'use client';
import React, { useState } from 'react';
import Button from '@/components/ui/Button';
import useSharedRef from '@/hooks/useSharedRef';
import Slider from '@/components/ui/Slider';
export default function ProductPage() {
  const [email, setEmail] = useState('');
  const modalRef = useSharedRef('modalRef');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const onBookDemoClick = (sendEmail?: boolean) => {
    modalRef?.current?.open?.(sendEmail ? email : '');
    setEmail('');
  };

  return (
    <>
      {/* Hero Section */}
      <section className="w-full px-4 sm:px-6 lg:px-14 lg:max-w-[1330px] mx-auto flex flex-col gap-8 sm:gap-10 lg:gap-12">
        {/* Hero Content */}
        <div className="flex flex-col gap-8 sm:gap-12 lg:gap-15 px-4 sm:px-8 lg:px-14">
          <div className="flex flex-col gap-6 sm:gap-8 lg:gap-9">
            <div className="flex flex-col gap-6 sm:gap-8 lg:gap-8.5">
              {/* Hero Text Section */}
              <div className="w-full flex flex-col items-center gap-3 sm:gap-5 md:gap-[1.875rem]">
                <h1 className="leading-tight sm:leading-[128%] md:leading-[128%] lg:leading-[128%] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium font-ibm-plex text-center text-[#212a31] max-w-6xl ">
                  Maximize Yield, Productivity and Quality using AI
                </h1>
                <p className="text-base sm:leading-[160%] md:leading-[160%] lg:leading-[160%] sm:text-[1.125rem] md:text-\1.25r\em] font-lighter font-ibm-plex text-center text-[#212A31] max-w-7xl">
                  SixSense’s AI suite turbo-charges fabs and OSAT lines by automating defect
                  review at scale, tracing recurring faults to their root cause, and instantly
                  flagging at-risk wafers. The result: less yield exposure, tighter quality
                  control, higher productivity and higher confidence on every run.
                </p>
              </div>
              {/* Email Signup Form */}
              <div className="w-full mx-auto">
                <div className="w-full max-w-md sm:max-w-lg md:max-w-xl flex items-center bg-white border border-[#eaeaea] rounded-md shadow-[0px_4px_64px_#00000014] p-2 mx-auto">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    className="flex-1 px-3 py-2 text-sm sm:text-base text-[#627c937f] font-inter bg-transparent border-none outline-none"
                    onChange={handleEmailChange}
                  />
                  <Button
                    variant="primary"
                    size="sm"
                    type="submit"
                    className="bg-[#1449ea] text-white px-3 py-2 sm:px-4 sm:py-2.5 text-sm sm:text-base font-normal font-ibm-plex rounded-md"
                    onClick={() => {
                      onBookDemoClick(true);
                    }}
                  >
                    Book a Demo
                  </Button>
                </div>
              </div>
            </div>
            <img src="/images/feature-distribution.png" alt="Feature Distribution" />
          </div>
          {/* Trusted Companies Section */}
          <div className="flex flex-col items-center gap-[40px]">
            <p className="text-lg sm:text-xl lg:text-2xl font-medium font-ibm-plex text-center text-black">
              Trusted by Top Semiconductor companies
            </p>
            <div className='flex flex-col items-center gap-4'>
              <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-10 md:gap-12">
                <img src="/images/img_image_22.png" alt="Company 1" className="h-8 sm:h-10 w-auto" />
                <img src="/images/img_image_logo_statschip.png" alt="Company 2" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_raytek.png" alt="Company 3" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_wavetek.png" alt="Wavetek" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_theil.png" alt="theil" className="h-12 sm:h-16 w-auto" />
              </div>
              <div className="sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[0.875rem] text-center lg:max-w-full font-medium font-ibm-plex text-[#212a31]">
                Including many other industry leader across Singapore, Taiwan, Malaysia, China,
                Israel and US.
              </div>
            </div>
          </div>
          {/* video Section */}
          <div className="w-full flex flex-col items-center gap-3 sm:gap-4 md:gap-6">
            <div className="w-full flex flex-col items-center gap-1.5">
              <h1 className="text-[1rem] sm:text-[1.5rem] md:text-[2rem] lg:text-[2.5rem] font-medium font-ibm-plex text-center text-black max-w-full ">
                Unlock 95% of your fab’s hidden intelligence
              </h1>
            </div>
            <iframe
              src="https://drive.google.com/file/d/1kdF384dFH_2xLFE0u_yDGpgqYBGPM2k8/preview"
              allow="autoplay"
              className="h-[85vh]  w-full max-w-[1100px] max-h-[600px] aspect-[11/6] rounded-2xl"
            />
          </div>
        </div>
      </section>
      {/* AI-ADC Section */}
      <section className="w-full bg-[#fafafb] py-12 sm:py-16 lg:py-18">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-22">
          <div className="flex flex-col justify-start gap-8 sm:gap-10">
            <div className="text-center px-2 sm:px-4">
              <h2 className="text-[40px] text-center font-medium font-ibm-plex text-black">
                AI-ADC: End-to-End Visual Inspection, Automated.
              </h2>
            </div>
            <div
              className="flex flex-col-reverse sm:flex-row p-8 items-start gap-9 self-stretch rounded-lg border border-solid border-[#E1EEFE] bg-[#FAFAFB]"
              style={{ flex: '1 0 0', boxShadow: '0 4px 64.87px 0 rgba(0, 0, 0, 0.08)' }}
            >
              <div className="w-full sm:w-[50%] flex flex-col gap-5">
                <p>
                  <strong className="text-[#1F9AC3]">AI-ADC</strong> is our end-to-end solution for
                  automating visual inspection. With tools for training, deployment, and
                  maintenance, it delivers faster accurate defect classification with fewer labeled
                  samples—reducing cycle time and cleanroom footprint.
                </p>
                <ul className="list-disc list-inside flex flex-col gap-5">
                  <li>
                    <strong className="text-[#1F9AC3]">Build AI</strong> is end-to-end environment
                    for <strong className="text-[#1F9AC3]">preparing training data</strong> with{' '}
                    <strong className="text-[#1F9AC3]">least effort</strong> and building{' '}
                    <strong className="text-[#1F9AC3]">high-accuracy</strong> AI models. It enables
                    sampling of most useful images automatically and model training with minimal
                    manual effort and exceptional accuracy.
                  </li>
                  <li>
                    <strong className="text-[#1F9AC3]">ClassifAI runs AI models</strong> in
                    production from across AOI tools. It enables high-throughput and low-latency
                    visual inspection with{' '}
                    <strong className="text-[#1F9AC3]">near-zero escapes</strong>.
                  </li>
                  <li>
                    <strong className="text-[#1F9AC3]">VerifAI</strong> is a smart toolkit to{' '}
                    <strong className="text-[#1F9AC3]">auto monitor</strong> and{' '}
                    <strong className="text-[#1F9AC3]">adapt</strong> production models — with drift
                    detection and <strong className="text-[#1F9AC3]">self improvement</strong>{' '}
                    capabilities to ensure reliable performance in production
                  </li>
                </ul>
              </div>
              <div className="w-full sm:w-[50%]">
                <img src="/images/Ai-ADC-flow-1.svg" alt="Ai ADC Flow" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Build AI Section */}
      <section className="w-full flex flex-col gap-8">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6">
          <div className="text-center px-2 sm:px-4">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium font-ibm-plex text-black">
              Build AI: Train smarter, not harder
            </h2>
          </div>
        </div>
        {/* Horizontal Scrolling List */}
        <div className="w-full px-6 sm:px-7">
          <Slider showArrows infinite maxSlideWidthPx={917}>
                {/* Smart Data Preparation */}
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-8 shadow-[0px_4px_64px_#00000014] max-w-[1100px] px-12 flex-shrink-0 h-full flex">
                  <div className="flex flex-col lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 lg:w-1/2">
                      <div className="flex items-center">
                        <h3 className="text-base sm:text-lg lg:text-xl font-medium font-ibm-plex text-black">
                          <strong className="text-[#1F9AC3]">Smart Data preparation</strong>
                        </h3>
                      </div>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          Pick a <strong className="text-[#1F9AC3]">diverse</strong>, balanced,
                          de-duplicated set—including{' '}
                          <strong className="text-[#1F9AC3]">hard-to-find</strong> examples from
                          millions of images.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">AI-assisted label correction</strong>{' '}
                          at 10x speed.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Launch once with <strong className="text-[#1F9AC3]">0% escapee</strong> in
                          production;{' '}
                          <strong className="text-[#1F9AC3]">skip endless retrains</strong> and
                          rollbacks.
                        </li>
                      </ul>
                    </div>
                    <div className="lg:w-1/2 flex items-center justify-end">
                      <img
                        src="/images/img_screenshot_2025_06_25.png"
                        alt="Smart Data Preparation"
                        className="w-full max-w-[400px] max-h-[322px] h-auto rounded-xl"
                      />
                    </div>
                  </div>
                </div>
                {/* Classification Detection */}
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-8 shadow-[0px_4px_64px_#00000014] max-w-[1100px] px-12 flex-shrink-0 h-full flex">
                  <div className="flex flex-col lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 lg:w-2/5">
                      <p className="text-base sm:text-lg lg:text-xl font-medium font-ibm-plex leading-7 sm:leading-8 text-black">
                        <strong className="text-[#1F9AC3]">
                          Classification {'>>'} Detection and Anomaly detection
                        </strong>
                      </p>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          True classification models—
                          <strong className="text-[#1F9AC3]">no patched detection</strong> or
                          anomaly workarounds.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">Skip bounding boxes;</strong> data prep
                          is quick and easy.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">High accuracy</strong> even on
                          extremely <strong className="text-[#1F9AC3]">small</strong> and{' '}
                          <strong className="text-[#1F9AC3]">similar looking defects</strong>
                        </li>
                      </ul>
                    </div>
                    <div className="lg:w-3/5 flex items-center justify-end">
                      <div className="bg-white rounded-xl p-6 py-10">
                        <img
                          src="/images/classification_detection.svg"
                          alt="Classification Detection"
                          className="w-full max-w-[400px] h-auto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Foundation Models */}
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-8 shadow-[0px_4px_64px_#00000014] max-w-[1100px] px-12 flex-shrink-0 h-full flex">
                  <div className="flex flex-col lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 lg:w-1/2">
                      <p className="text-base sm:text-lg lg:text-xl font-medium font-ibm-plex leading-7 sm:leading-8 text-black">
                        <strong className="text-[#1F9AC3]">
                          Large vision foundation models specialized for semiconductors
                        </strong>
                      </p>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">Pre-trained</strong> on millions of
                          wafer-defect images.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Thinks like a PhD, not a high-schooler — learns faster,{' '}
                          <strong className="text-[#1F9AC3]">performs smarter</strong>.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Delivers{' '}
                          <strong className="text-[#1F9AC3]">{'>'} 95% automation, 0% UR,</strong>{' '}
                          and up to <strong className="text-[#1F9AC3]">{'<'} 0.05% OR</strong>{' '}
                          (using image count in just 2-digit instead of 4-digits per class).
                        </li>
                      </ul>
                    </div>
                    <div className="lg:w-1/2 flex items-center justify-end">
                      <img
                        src="/images/img_image_3.png"
                        alt="Foundation Models"
                        className="w-[322px] h-[322px] rounded-[10px]"
                      />
                    </div>
                  </div>
                </div>
                {/* Explainable AI */}
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-8 shadow-[0px_4px_64px_#00000014] max-w-[1100px] px-12 flex-shrink-0 h-full flex">
                  <div className="flex flex-col lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 lg:w-1/2">
                      <p className="text-base sm:text-lg lg:text-xl font-medium font-ibm-plex leading-7 sm:leading-8 text-black">
                        <strong className="text-[#1F9AC3]">Explainable AI</strong>
                      </p>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">Verify</strong> what your AI learns and
                          launch it only when you believe it!.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          <strong className="text-[#1F9AC3]">No black-box</strong> AI any more!.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Look inside the <strong className="text-[#1F9AC3]">model’s brain</strong>
                          and see ‘what’ it recognizes as defect.
                        </li>
                      </ul>
                    </div>
                    <div className="lg:w-1/2 flex items-center justify-end">
                      <img
                        src="/images/ExplainableAI.svg"
                        alt="Explainable AI"
                        className="w-[400px] h-[322px]"
                      />
                    </div>
                  </div>
                </div>
          </Slider>
        </div>
      </section>
      {/* ClassifAI Section */}
      <section className="w-full py-0">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col gap-8">
            <div className="text-center px-2.5">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium font-ibm-plex text-black">
                ClassifAI: Smart & Scalable Defect Classification — Built for High-Throughput
                Inspection Lines
              </h2>
            </div>
            <div className="flex justify-center">
              <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1280px]">
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  <div className="flex flex-col gap-5 lg:w-1/2">
                    <div className="flex items-center">
                      <h3 className="text-base sm:text-lg lg:text-xl text-center sm:text-left font-medium font-ibm-plex text-black">
                        <strong className="text-[#1F9AC3]">Seamlessly run in production</strong>
                      </h3>
                    </div>
                    <ul className="list-disc list-inside flex flex-col gap-5">
                      <li className="[text-indent:-1.5rem] ml-6">
                        <strong className="text-[#1F9AC3]">Single model</strong> covers{' '}
                        <strong className="text-[#1F9AC3]">hundreds of devices</strong> and tools
                        across generations.
                      </li>
                      <li className="[text-indent:-1.5rem] ml-6">
                        Built-in support for{' '}
                        <strong className="text-[#1F9AC3]">multi-view, multi-tool</strong> and
                        multiple magnifications.
                      </li>
                      <li className="[text-indent:-1.5rem] ml-6">
                        Ready integrations for{' '}
                        <strong className="text-[#1F9AC3]">Rescans, Klarf variants</strong>, and{' '}
                        <strong className="text-[#1F9AC3]">incoming defects</strong>—deployable by
                        yield engineers.
                      </li>
                    </ul>
                  </div>
                  <div className="lg:w-1/2 flex items-center justify-center">
                    <img
                      src="/images/classifAi-chart.svg"
                      alt="ClassifAI Production Interface"
                      className="w-full max-w-[612px] h-auto rounded-xl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Operator Interface Section */}
      <section className="w-full">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col gap-8">
            <div className="text-center px-2 sm:px-4">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium font-ibm-plex text-black">
                Operator-First Production Interface
              </h2>
            </div>
            <div className="flex justify-center">
              <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-6 sm:p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1330px] mx-4 sm:mx-6 lg:mx-22">
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  <div className="flex flex-col gap-5 lg:w-2/5">
                    <div className="flex items-center">
                      <h3 className="text-base sm:text-lg lg:text-xl text-center sm:text-left font-medium font-ibm-plex text-black">
                        Seamlessly run in production
                      </h3>
                    </div>
                    <ul className="list-disc list-inside flex flex-col gap-5">
                      <li className="[text-indent:-1.5rem] ml-6">
                        AI auto-grades and funnels{' '}
                        <strong className="text-[#1F9AC3]">new defects</strong> to the built-in
                        manual review interface - allows for 1-click retraining.
                      </li>
                      <li className="[text-indent:-1.5rem] ml-6">
                        Familiar Operator UI with minimal learning curve.
                      </li>
                      <li className="[text-indent:-1.5rem] ml-6">
                        Tools such as{' '}
                        <strong className="text-[#1F9AC3]">interactive wafer maps, hotkeys</strong>{' '}
                        and color‑coded defect maps give a head start in adoption.
                      </li>
                    </ul>
                  </div>
                  <div className="lg:w-3/5 flex items-center justify-center">
                    <img
                      src="/images/mdc-flow.svg"
                      alt="Operator Interface"
                      className="w-full max-w-[728px] h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lot Disposition Section */}
      <section className="w-full bg-white">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col gap-12">
            <div className="flex flex-col gap-12">
              <div className="text-center">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl text-center font-medium font-ibm-plex text-black">
                  Lot Disposition & Root-Cause Analysis
                </h2>
              </div>
              <div className="flex justify-center">
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-6 sm:p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1330px] mx-4 sm:mx-6 lg:mx-22">
                  <div className="flex flex-col-reverse lg:flex-row gap-9">
                    <p className="text-base sm:text-[1rem] lg:text-[1rem] font-normal font-ibm-plex leading-7 sm:leading-8 text-black lg:w-3/5 text-center sm:text-left">
                      Built on AI-ADC's trusted labels, Lot Disposition auto-decides pass, hold,
                      rework, or scrap for each lot. It balances yield impact, recurrence patterns,
                      and severity risk, then writes the verdict straight into your
                      systems—eliminating manual sign-offs, avoiding costly excursions, and keeping
                      cycle time lean even at peak throughput.
                    </p>
                    <div className="lg:w-2/5 flex items-center justify-center">
                      <img
                        src="/images/img_screenshot_2025_06_24.png"
                        alt="Lot Disposition Interface"
                        className="w-full max-w-[540px] h-auto rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Dispose AI Section */}
            <div className="flex flex-col gap-8">
              <div className="text-center px-2 sm:px-4">
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium font-ibm-plex text-black">
                  Dispose AI
                </h2>
              </div>
              <div className="flex justify-center">
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-6 sm:p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1330px] mx-4 sm:mx-6 lg:mx-22">
                  <div className="flex flex-col-reverse lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 flex-grow">
                      <div className="flex items-center">
                        <h3 className="text-base sm:text-[1rem] lg:text-[1rem] leading-[160%] font-bold font-ibm-plex text-black text-center sm:text-left">
                          <strong className="text-[#1F9AC3]">Seamless lot disposition</strong>
                        </h3>
                      </div>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          Surfaces critical{' '}
                          <strong className="text-[#1F9AC3]">repeating defects</strong>, wafer-map
                          signatures, and <strong className="text-[#1F9AC3]">yield outliers</strong>
                          .
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Enables <strong className="text-[#1F9AC3]">auto-lot checkout</strong>{' '}
                          decisions for yield engineers based on yield criteria and low kill-ratio
                          defects.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Puts lots with{' '}
                          <strong className="text-[#1F9AC3]">low first pass yield</strong> or low{' '}
                          <strong className="text-[#1F9AC3]">final yield</strong> on hold for
                          review.
                        </li>
                      </ul>
                    </div>
                    <div className="flex items-center flex-shrink">
                      <img
                        src="/images/disposeAi.gif"
                        alt="Dispose AI"
                        className="w-[400px] h-auto"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* CausifAI Section */}
            <div className="flex flex-col gap-8">
              <div className="text-center px-2 sm:px-4">
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-medium font-ibm-plex text-black">
                  CausifAI
                </h2>
              </div>
              <div className="flex justify-center">
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-6 sm:p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1330px]">
                  <div className="flex flex-col-reverse lg:flex-row gap-9">
                    <div className="flex flex-col gap-5 lg:w-full mt-2.5">
                      <div className="flex items-center">
                        <h3 className="text-base sm:text-[1rem] lg:text-[1rem] leading-[160%] font-bold font-ibm-plex text-black text-center sm:text-left">
                          <strong className="text-[#1F9AC3]">Faster Root Cause Analysis</strong>
                        </h3>
                      </div>
                      <ul className="list-disc list-inside flex flex-col gap-5">
                        <li className="[text-indent:-1.5rem] ml-6">
                          Pin points key sources of failure by{' '}
                          <strong className="text-[#1F9AC3]">
                            correlating process tool, lot history{' '}
                          </strong>
                          and <strong className="text-[#1F9AC3]">inspection data</strong>.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Quantifies <strong className="text-[#1F9AC3]">wafer exposure</strong> via
                          wafer-stack analytics.
                        </li>
                        <li className="[text-indent:-1.5rem] ml-6">
                          Reports and charts for yield engineers to trace back{' '}
                          <strong className="text-[#1F9AC3]">sources</strong> of true and false{' '}
                          <strong className="text-[#1F9AC3]">yield loss </strong>.
                        </li>
                      </ul>
                    </div>
                    <div className="flex items-center lg:w-full">
                      <img src="/images/causifAI.svg" alt="Causif AI" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Predict AI Section */}
      <section className="w-full bg-[#fafafb]">
        <div className="w-full lg:max-w-[1330px] mx-auto px-4 sm:px-6 pt-[4.5rem] pb-12">
          <div className="flex flex-col gap-12">
            <div className="flex flex-col gap-12">
              <div className="text-center px-2 sm:px-4">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl sm:leading-[160%] lg:leading-[160%] font-medium font-ibm-plex text-black">
                  Predict AI: Predict and Pinpoint Yield Risks
                </h2>
              </div>
              <div className="flex justify-center">
                <div className="bg-[#fafafb] border border-[#e1eefe] rounded-lg p-6 sm:p-8 shadow-[0px_4px_64px_#00000014] w-full max-w-[1330px] mx-4 sm:mx-6 lg:mx-22">
                  <div className="flex flex-col-reverse lg:flex-row gap-9">
                    <div className="flex flex-col justify-center sm:justify-start items-center sm:items-start gap-5 lg:w-[652px]">
                      <div className="flex items-center sm:items-start">
                        <h3 className="text-base sm:text-lg lg:text-xl leading-[160%] sm:leading-[160%] lg:leading-[160%] font-bold font-ibm-plex text-black text-center sm:text-left">
                          <strong className="text-[#1F9AC3]">Predict AI</strong>
                        </h3>
                      </div>
                      <div className="pl-6">
                        <ul className="list-disc">
                          <li className="text-black text-base sm:text-[1rem] lg:text-[1rem] leading-[160%] font-ibm-plex">
                            <strong>Forecast Defects Early</strong> – Predict{' '}
                            <strong className="text-[#1F9AC3]">die failure probabilities</strong>{' '}
                            from inspection, metrology, and process data in early steps.
                          </li>
                        </ul>
                      </div>
                      <div className="pl-6">
                        <ul className="list-disc">
                          <li className="text-black text-base sm:text-[1rem] lg:text-[1rem] leading-[160%] font-ibm-plex">
                            <strong>Target High-Risk Areas</strong> – Identify layers, tools, and
                            patterns driving repeat defects, and{' '}
                            <strong className="text-[#1F9AC3]">dynamically focus sampling</strong>{' '}
                            where it matters.
                          </li>
                        </ul>
                      </div>
                      <div className="pl-6">
                        <ul className="list-disc">
                          <li className="text-black text-base sm:text-[1rem] lg:text-[1rem] leading-[160%] font-ibm-plex">
                            <strong>Prevent Scrap Before It Starts</strong> – Trigger proactive{' '}
                            <strong className="text-[#1F9AC3]">tool and recipe adjustments</strong>{' '}
                            and reduce unplanned downtime with self-optimizing, data-driven
                            production.
                          </li>
                        </ul>
                      </div>
                      <div className="relative w-[160px] h-[60px] ">
                        <div className="flex items-center justify-center sm:justify-start">
                          <Button
                            variant="outline"
                            size="sm"
                            className="px-2.5 py-2.5 text-base sm:text-lg lg:text-xl font-normal font-ibm-plex text-[#2250ce] bg-[#F1F5FE] border border-[#2250ce] rounded-md"
                          >
                            <span className="text-[#2250CE] text-xl">Coming Soon</span>
                          </Button>
                        </div>
                        <img
                          src="/images/img_vector_yellow_800_01.svg"
                          alt="Decoration 1"
                          className="absolute top-0 right-0 w-[18px] h-[18px]"
                        />
                        <img
                          src="/images/img_vector_yellow_800_01.svg"
                          alt="Decoration 2"
                          className="absolute bottom-0 left-0 w-[18px] h-[18px]"
                        />
                      </div>
                    </div>
                    <div className="lg:w-[528px] flex items-center justify-end">
                      <img
                        src="/images/img_screenshot_2025_06_25_484x528.png"
                        alt="Predict AI Interface"
                        className="w-auto h-auto rounded-2xl"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* CTA Section */}
            {/* <div className="flex justify-center">
              <div className="bg-white border border-[#e1eefe] rounded-lg p-6 sm:p-8 w-full max-w-[1330px]">
                <div className="flex flex-col lg:flex-row items-center gap-4">
                  <div className="flex flex-col gap-4 lg:flex-1 mt-1">
                    <h3 className="text-xl sm:text-2xl lg:text-3xl font-medium font-sans text-[#05090e]">
                      Improve your Quality Check Process Today
                    </h3>
                    <p className="text-base font-normal font-ibm-plex text-[#4D6896]">
                      Generate an endless flow of ideas in minutes. Polished, personalized and
                      relevant copy – that is guaranteed to convert!
                    </p>
                  </div>
                  <div className="flex items-center">
                    <Button
                      variant="primary"
                      size="md"
                      className="p-2.5 text-base sm:text-lg lg:text-xl font-normal font-ibm-plex bg-[#2250CE] text-white rounded-md"
                      onClick={() => onBookDemoClick(false)}
                    >
                      Book a Demo
                    </Button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}
